var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzul(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5061AA;}\n\t.st1{fill:#8B328A;}\n\t.st2{fill:#5D80C0;}\n\t.st3{fill:#E94E29;}\n\t.st4{fill:#D5262A;}\n\t.st5{fill:#F6A022;}\n\t.st6{fill:#6A95CD;}\n\t.st7{fill:#306FB6;}\n\t.st8{fill:#73C8DD;}\n\t.st9{fill:#92C143;}\n\t.st10{fill:#169BD6;}\n\t.st11{fill:#199AA6;}\n\t.st12{fill:#A5BFDF;}\n\t.st13{fill:#3FB7AF;}\n\t.st14{fill:#AE2258;}\n\t.st15{fill:#79C199;}\n\t.st16{fill:#E5DF1F;}\n\t.st17{fill:#33BACF;}\n\t.st18{fill:#6CA9DB;}\n\t.st19{fill:#DE5097;}\n\t.st20{fill:#604596;}\n\t.st21{fill:#FAD803;}\n\t.st22{fill:#0BB8E7;}\n\t.st23{fill:#41AD4C;}\n\t.st24{fill:#E7B720;}\n\t.st25{fill:#B9CF37;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.2,11.1h5.7v4.5h-5.7L61.2,11.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.3,58.8h17.3v18.5H40.3V58.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.7,81.2h11.4v6.9H51.7V81.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45,84.4h13.7V98H45L45,84.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M61.9,72.1h11.7v5.1H61.9L61.9,72.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M57.6,62.8h12v3h-12V62.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.6,72.1H82v2.3h-8.4V72.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M57.6,48.1h11.5v14.7H57.6V48.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M35.2,36.8h22.4v22H35.2V36.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M22.2,36.8h15V49h-15V36.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.6,16.3H67V37H41.6V16.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M69.1,39.5h18.5v22.6H69.1V39.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M66.2,52.4H82v19.8H66.2L66.2,52.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M57.6,65.8h11.7v11.4H57.6V65.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M50.8,73h15.1v8.3H50.8L50.8,73z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M82,60.1h3.2V70H82V60.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M87.6,38.8H96V44h-8.5L87.6,38.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M86.8,44h6.1v3.4h-6.1V44z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M57.6,28h11.5v20.1H57.6V28z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M69.1,19.9h15.4v19.6H69.1L69.1,19.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M67,16.3h11.2v18.4H67V16.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M82.2,34.1h15.3v5.4H82.2V34.1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M84.5,22.3h7.3v11.8h-7.3V22.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M89.7,26h6.8v5h-6.8V26z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M87.9,31h9.6v5h-9.6V31z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.1,10.9h5.8v4.7h-5.8V10.9z M41.6,11h10.5v11.6H41.6V11z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M9.3,11h32.4v26H9.3V11z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M25.9,2h11.3v14.7H25.9V2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M2.5,34.8h20.9v8.1H2.5V34.8z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M52.1,3.4h8.1v12.9h-8.1V3.4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M62.9,52.4h3.3v3.3h-3.3L62.9,52.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzul);
export default __webpack_public_path__ + "static/media/azul.85f9cd798995ee317d5a6c99f37cf75c.svg";
export { ForwardRef as ReactComponent };